import React, { useEffect, useState } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import {
  TextField,
  Grid,
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Card,
  FormControlLabel,
  Checkbox,
  CardContent
} from '@mui/material';
import statelist from '../../../utils/StateDistList.json';
import CoordinateDetails from './CoordinateDetails';

export default function AddressDetails() {
  const { control, setValue, watch } = useFormContext();
  const [bothAddressSame, setBothAddressSame] = useState(false);

  const selfAddress = watch('selfAddress');
  const serviceAddress = watch('serviceAddress');

  // const same = watch('same');
  const selfAddressState = watch('selfAddress.state');
  const selfAddressAddress = watch('selfAddress.address');
  const selfAddressCity = watch('selfAddress.city');
  const selfAddressPincode = watch('selfAddress.pincode');
  const selfAddressLandMark = watch('selfAddress.landmark');
  const selfAddressMobile = watch('selfAddress.mobileNumber');
  const selfAddressLatitude = watch('selfAddress.latitude');
  const selfAddressLongitude = watch('selfAddress.longitude');

  useEffect(() => {

    if (bothAddressSame) {
      setValue('serviceAddress.address', selfAddressAddress, { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.state', selfAddressState, { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.city', selfAddressCity, { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.pincode', selfAddressPincode, { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.landmark', selfAddressLandMark, { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.mobileNumber', selfAddressMobile, { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.latitude', selfAddressLatitude, { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.longitude', selfAddressLongitude, { shouldValidate: true, shouldDirty: true });
    }
  }, [bothAddressSame, selfAddressState, selfAddressCity, selfAddressAddress, selfAddressPincode, selfAddressLandMark, selfAddressMobile, selfAddressLatitude, selfAddressLongitude], { shouldValidate: true, shouldDirty: true });

  const handleAddressChange = (e) => {
    const { checked } = e.target;
    setBothAddressSame(checked);
    if (!checked) {
      setValue('serviceAddress.address', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.state', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.city', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.pincode', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.landmark', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.mobileNumber', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.latitude', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.longitude', '', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.serviceArea', '1', { shouldValidate: true, shouldDirty: true });
      setValue('serviceAddress.addressType', '1', { shouldValidate: true, shouldDirty: true });
    }
  };

  useEffect(() => {
    // Check if addresses are the same when component mounts
    const addressesAreSame = Object.keys(selfAddress).every(
      key => selfAddress[key] === serviceAddress[key]
    );
    // console.log("address is same:",addressesAreSame)
    setBothAddressSame(addressesAreSame);
  }, []);

  const renderAddressFields = (prefix, disabled = false) => (
    <>
      <Grid item xs={12} sm={8} md={9}>
        <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Landmark</Typography>
        <Controller
          name={`${prefix}.landmark`}
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              fullWidth
              size='small'
              InputProps={{
                style: {
                  // height:'2rem',
                  fontSize: '.75rem'
                },
                // inputProps:{
                //     style:{textTransform:"uppercase"},
                // }   
              }}
              disabled={disabled}
              // InputProps={{ inputProps: { style: { textTransform: "uppercase" } } }}
              error={!!error}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={3}>
        <Typography sx={{ fontWeight: '600', texttTransform: 'uppercase', display: 'flex ', alignItems: 'center', fontSize: '0.75rem' }}>Contact Number </Typography>
        <Controller
          name={`${prefix}.mobileNumber`}
          control={control}
          rules={{
            validate: (value) => {
              if (!value) return true;
              if (value[0] === '0') {
                return "Mobile number cannot start with 0";
              }
              if (value.length !== 10) {
                return "Mobile number must be exactly 10 digits";
              }



              if (!/^\d+$/.test(value)) {
                return "Only numbers are allowed";
              }

              return true;
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              size='small'
              sx={{width:{xs:'100%',sm:'auto'}}}
              error={!!error}
              helperText={error?.message}
              inputProps={{
                maxLength: 10,
              }}
              InputProps={{
                style: {
                  // height:'2rem',
                  fontSize: '.75rem'
                },
                // inputProps:{
                //     style:{textTransform:"uppercase"},
                // }   
              }}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                field.onChange(value);
              }}
            />
          )}
        />
      </Grid>
    </>
  );

  return (
    <Grid item xs={12}>
      <Card sx={{ mb: 1 }}>
        <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
          <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>Address Info</Typography>
        </Box>
        <CardContent sx={{ p: 1 }}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Card sx={{ my: 0.5, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
                <Box sx={{ borderBottom: '2px solid lightGray' }}>
                  <Typography sx={{ p: '.5% 2%', fontWeight: '600', bgcolor: 'lightGray', width: 'fit-content', fontSize: '.75rem' }}>Expert Service Address</Typography>
                </Box>
                <Grid container spacing={1} sx={{ p: '2%', pt: { xs: 1, md: 5.5 } }}>

                  <CoordinateDetails prefix="selfAddress" />
                  {renderAddressFields('selfAddress')}
                </Grid>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{ my: 0.5, borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}>
                <Box sx={{ borderBottom: '2px solid lightGray' }}>
                  <Typography sx={{ p: '.5% 2%', fontWeight: '600', bgcolor: 'lightGray', width: 'fit-content', fontSize: '.75rem' }}>Expert Home Address</Typography>
                </Box>
                <Grid container spacing={1} sx={{ p: '2%', pt: 0 }}>
                  <Grid item xs={12} sx={{}}>
                    <FormControlLabel
                      sx={{
                        '& .MuiFormControlLabel-label': { fontSize: '.75rem' },
                      }}
                      control={
                        <Checkbox
                          checked={bothAddressSame}
                          onChange={handleAddressChange}
                        />
                      }
                      label="Same as Home Address"
                    />
                  </Grid>

                  <CoordinateDetails prefix="serviceAddress" />
                  {renderAddressFields('serviceAddress', bothAddressSame)}
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}